if (!customElements.get('vbb-action-atc')) {
  customElements.define('vbb-action-atc', class MultiATC extends HTMLElement {
    constructor() {
      super();

      this.cta = this.querySelector('button');
      this.action = this.dataset.action;
    }

    fireAction() {
      publish(PUB_SUB_EVENTS[this.action]);
    }

    connectedCallback() {
      this.cta.addEventListener('click', () => this.fireAction());
    }

    disconnectedCallback() {
      this.cta.removeEventListener('click', () => this.fireAction());
    }
  });
}
